import { CSSProperties, useState } from "react";
import { Staker } from "../../helpers/stake-helpers";

const MAX_VISIBLE_AVATARS = 5

// a twitch profile picture, or the staker's initial when they have none or it fails to load
const StakerAvatar = ({ staker, index }: { staker: Staker, index: number }) => {
  const [hasImageFailed, setHasImageFailed] = useState(false)
  const showImage = staker.avatarUrl && !hasImageFailed

  return (
    <span className="bet_list__staker_avatar" style={{ '--index': index } as CSSProperties} title={staker.name}>
      {showImage
        ? <img src={staker.avatarUrl!} alt={staker.name} onError={() => setHasImageFailed(true)} />
        : <span className="bet_list__staker_initial pl-fontXSContrast">{staker.name.charAt(0).toUpperCase()}</span>}
    </span>
  )
}

// the stakers backing this bet as an overlapping stack. each avatar pops in as it mounts, so a new staker
// arriving mid stream animates in on its own, then they all bob in a slow wave
export const StakerAvatars = ({ stakers }: { stakers: Staker[] }) => {
  const visibleStakers = stakers.slice(0, MAX_VISIBLE_AVATARS)
  const hiddenCount = stakers.length - visibleStakers.length

  return (
    <div className="bet_list__stakers">
      <span className="bet_list__stakers_label pl-fontXS">
        Backed by {stakers.length} {stakers.length === 1 ? 'staker' : 'stakers'}
      </span>
      <span className="bet_list__staker_stack">
        {visibleStakers.map((staker, index) => <StakerAvatar key={staker.id} staker={staker} index={index} />)}
        {hiddenCount > 0 && (
          <span
            className="bet_list__staker_avatar bet_list__staker_avatar--more pl-fontXSContrast"
            style={{ '--index': visibleStakers.length } as CSSProperties}
          >
            +{hiddenCount}
          </span>
        )}
      </span>
    </div>
  )
}
